import { createSlice } from "@reduxjs/toolkit";
import { GadgetInstallationStatus, InstallationStatus } from "../../../helper/cloudcore/response/models/body";

export interface InstalledGadgetsState {
  deviceData: {
    [sourceDeviceId: string]: Record<number, GadgetInstallationStatus>
  }
}

const initialState: InstalledGadgetsState = {
  deviceData: {}
};

export const installedGadgetSlice = createSlice({
  name: "installedGadgets",
  initialState,
  reducers: {
    reset: (state, action) => {
      let newCurrentDeviceData = {};
      let gadgetsData = {};
      const allDeviceData = state.deviceData;
      Object.keys(state.deviceData).forEach((deviceId, index) => {
        newCurrentDeviceData = {};
        gadgetsData = {};
        const currentDeviceData = allDeviceData[deviceId];
        Object.keys(currentDeviceData).forEach((gadgetId, index) => {
          const newData: Record<number, GadgetInstallationStatus> = {};
          newData[parseInt(gadgetId)] = {
            progress: 0,
            status: InstallationStatus.ERROR
          };
          gadgetsData = {
            ...gadgetsData,
            ...newData
          }
        });
        newCurrentDeviceData = {
          [deviceId]: gadgetsData
        }
      });
      state.deviceData = {
        ...state.deviceData,
        ...newCurrentDeviceData
      }
    },
    resetByDeviceId: (state, action) => {
      const { deviceId } = action.payload;
      let gadgetsData = {};
      const allDeviceData = state.deviceData;
      const currentDeviceData = allDeviceData[deviceId];
      Object.keys(currentDeviceData).forEach((gadgetId, index) => {
        const newData: Record<number, GadgetInstallationStatus> = {};
        newData[parseInt(gadgetId)] = {
          progress: 0,
          status: InstallationStatus.ERROR
        };
        gadgetsData = {
          ...gadgetsData,
          ...newData
        }
      });
      const newCurrentDeviceData = {
        [deviceId]: gadgetsData
      }
      state.deviceData = {
        ...state.deviceData,
        ...newCurrentDeviceData
      }
    },
    update: (state, action) => {
      const { sourceDeviceId, gadgetId, status, progress } = action.payload;
      const newData: Record<number, GadgetInstallationStatus> = {};
      newData[gadgetId] = {
        progress,
        status
      };

      state.deviceData[sourceDeviceId] = {
        ...state.deviceData[sourceDeviceId],
        ...newData
      };
    }
  },
});

export const { reset, update, resetByDeviceId } = installedGadgetSlice.actions;
export default installedGadgetSlice.reducer;
